
    import './styles.scoped.css';
    export default {
  "placeholder": "awsui_placeholder_dwuol_ywf2u_3",
  "item": "awsui_item_dwuol_ywf2u_8",
  "checkbox": "awsui_checkbox_dwuol_ywf2u_12",
  "filter": "awsui_filter_dwuol_ywf2u_21",
  "trigger": "awsui_trigger_dwuol_ywf2u_26",
  "layout-strut": "awsui_layout-strut_dwuol_ywf2u_32",
  "list-bottom": "awsui_list-bottom_dwuol_ywf2u_38"
};
  